export function removeSpecialChars(value) {
	return value
		.normalize('NFD')
		.replace(/\p{Mn}/gu, '')
		.replace(/[^a-zA-Z0-9._ ]/g, '');
}
